// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3503":"8f811ae8","7159":"8f811ae8"}[chunkId] + ".chunk.css";
};